import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { Form, Input, Button, Alert, Typography } from 'antd'
import { ArrowRightOutlined } from '@ant-design/icons'
import { Logo } from '../../assets/icons/logo'
import {
  LoginLayout,
  SiteLayout,
  ContentLayout,
  LoginForm,
  HeaderContainer,
  LogoContainer,
  Title,
  StyledFormItem,
  ButtonContainer,
  Footer,
} from '../login/styles'

const layout = {
  labelCol: { span: 24 },
  wrapperCol: { span: 24 },
}

function platformAuthRecoverUrl(): string | null {
  const host = String(process.env.REACT_APP_PLATFORM_AUTH_HOST || '')
    .trim()
    .replace(/^https?:\/\//i, '')
    .replace(/\/+$/, '')
  return host ? `https://${host}/recover` : null
}

export default function PasswordRecoveryPage() {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [sent, setSent] = useState(false)
  const authRecover = platformAuthRecoverUrl()

  useEffect(() => {
    if (authRecover) {
      window.location.replace(authRecover)
    }
  }, [authRecover])

  if (authRecover) {
    return (
      <LoginLayout>
        <SiteLayout className="site-layout">
          <ContentLayout>
            <div style={{ padding: 24, textAlign: 'center' }}>
              <Typography.Text>Переход на страницу восстановления…</Typography.Text>
              <div style={{ marginTop: 12 }}>
                <a href={authRecover}>{authRecover}</a>
              </div>
            </div>
          </ContentLayout>
        </SiteLayout>
      </LoginLayout>
    )
  }

  const onFinish = async (values: any) => {
    setLoading(true)
    setError(null)
    try {
      const response = await fetch('/api/password-reset/request', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ identifier: String(values?.identifier || '').trim() }),
      })
      const data = await response.json().catch(() => ({}))
      if (!response.ok) {
        setError(data?.errors?.[0]?.detail || 'Не удалось отправить запрос')
        return
      }
      setSent(true)
    } catch {
      setError('Ошибка сети')
    } finally {
      setLoading(false)
    }
  }

  const currentYear = () => new Date().getFullYear()

  return (
    <LoginLayout>
      <SiteLayout className="site-layout">
        <ContentLayout>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <LoginForm {...layout} name="password-recovery" layout="vertical" onFinish={onFinish}>
              <HeaderContainer>
                <LogoContainer>
                  <Logo />
                </LogoContainer>
                <Title>Восстановление пароля</Title>
                <Typography.Text type="secondary" style={{ display: 'block', marginTop: 8 }}>
                  Укажите email или телефон — мы отправим ссылку на почту
                </Typography.Text>
                {error ? (
                  <Alert style={{ marginTop: 16 }} type="error" showIcon message={error} />
                ) : null}
                {sent ? (
                  <Alert
                    style={{ marginTop: 16 }}
                    type="success"
                    showIcon
                    message="На email отправлена ссылка для восстановления пароля"
                  />
                ) : null}
              </HeaderContainer>

              {!sent && (
                <>
                  <StyledFormItem
                    label="Email или телефон:"
                    name="identifier"
                    rules={[{ required: true, message: 'Укажите email или телефон' }]}
                  >
                    <Input placeholder="user@example.ru или +7…" autoComplete="username" />
                  </StyledFormItem>
                  <Form.Item>
                    <ButtonContainer>
                      <Button type="primary" htmlType="submit" loading={loading}>
                        Отправить ссылку <ArrowRightOutlined />
                      </Button>
                      <Link to="/login" style={{ fontSize: '90%' }}>
                        Вернуться ко входу
                      </Link>
                    </ButtonContainer>
                  </Form.Item>
                </>
              )}

              {sent && (
                <Form.Item>
                  <ButtonContainer>
                    <Button type="primary" onClick={() => navigate('/login')}>
                      На страницу входа
                    </Button>
                    <Button type="link" onClick={() => setSent(false)}>
                      Отправить ещё раз
                    </Button>
                  </ButtonContainer>
                </Form.Item>
              )}
            </LoginForm>
          </div>
        </ContentLayout>
        <Footer>&copy; 2020-{currentYear()} ООО «Аксиома». Все права защищены.</Footer>
      </SiteLayout>
    </LoginLayout>
  )
}
